export default __webpack_public_path__ + "static/media/8、首页冷链果汁.4c6d6494.jpg";